import { Col, ColorPicker, Form, Row } from "antd";
import React from "react";
import { injectIntl } from "react-intl";

function TeamColors(props) {
  const {
    form,
    intl: { formatMessage },
  } = props;

  return (
    <Row>
      <Col span={7}>
        <Form.Item
          labelCol={{
            span: 9,
          }}
          normalize={(value) => {
            return value.toHex();
          }}
          name="primary"
          label={formatMessage({
            id: "primary",
            defaultMessage: "Primary",
          })}
          tooltip={formatMessage(
            {
              id: "form.help.item.colour",
              defaultMessage: "Primary Colour",
            },
            {
              item: formatMessage({
                id: "primary",
                defaultMessage: "Primary",
              }),
            },
          )}
        >
          <ColorPicker
            showText={(color) => <span>({color.toHexString()})</span>}
            value={"#" + (form?.values?.colors?.primary || "ffffff")}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          labelCol={{
            span: 11,
          }}
          normalize={(value) => {
            return value.toHex();
          }}
          name="secondary"
          label={formatMessage({
            id: "secondary",
            defaultMessage: "Secondary",
          })}
          tooltip={formatMessage(
            {
              id: "form.help.item.colour",
              defaultMessage: "Secondary Colour",
            },
            {
              item: formatMessage({
                id: "secondary",
                defaultMessage: "Secondary",
              }),
            },
          )}
        >
          <ColorPicker
            showText={(color) => <span>({color.toHexString()})</span>}
            value={"#" + (form?.values?.colors?.secondary || "ffffff")}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          labelCol={{
            span: 9,
          }}
          normalize={(value) => {
            return value.toHex();
          }}
          name="tertiary"
          label={formatMessage({
            id: "tertiary",
            defaultMessage: "Tertiary",
          })}
          tooltip={formatMessage(
            {
              id: "form.help.item.colour",
              defaultMessage: "Tertiary Colour",
            },
            {
              item: formatMessage({
                id: "tertiary",
                defaultMessage: "Tertiary",
              }),
            },
          )}
        >
          <ColorPicker
            showText={(color) => <span>({color.toHexString()})</span>}
            value={"#" + (form?.values?.colors?.tertiary || "ffffff")}
          />
        </Form.Item>
      </Col>
    </Row>
  );
}

export default injectIntl(TeamColors);
